module.exports = __webpack_public_path__ + "searchSilver.png";